import { Descendant, Text } from 'slate'

import { VariableTextFeatureFlag } from '@makyoapp/makyo-common'

export const variableTextHasColumnValue = (value: Descendant | Descendant[]): boolean => {
  if (!value) return false

  if (Text.isText(value)) {
    return false
  }

  if (Array.isArray(value)) {
    return value.some((v) => variableTextHasColumnValue(v))
  }

  // Check if this node is of type ColumnData
  if (typeof value.type !== 'undefined' && Number(value.type) === VariableTextFeatureFlag.CurrentListItem) {
    return true
  }

  // Recursively check children
  if (Array.isArray(value.children)) {
    return value.children.some((v) => variableTextHasColumnValue(v))
  }

  return false
}
